module.exports = __webpack_public_path__ + "static/media/p1.18b380cc.svg";